import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import styles from './Contact.module.scss'

type Props = {
  formId: string
}

export const Contact: React.FC<Props> = ({ formId }) => {
  useHubSpotGenerate('na1', '9395227', `${formId}`, '#sp_hbspt')

  return (
    <div className={styles.contact_container} id="contact">
      <div className={styles.main_container}>
        <div className={styles.content_container}>
          <p className={styles.title}>お問い合わせ</p>
          <div className={styles.form_container}>
            <p className={styles.form_title}>※ 全ての項目をご入力ください。</p>
            <div className={styles.hubSpot} id="sp_hbspt"></div>
          </div>
        </div>
      </div>
    </div>
  )
}
